<template>
  <div class="landing-page horizontal ltr">
    <LandingHeader />

    <main>
      <router-view />
    </main>

    <LandingFooter />
  </div>
</template>

<script>


  import LandingHeader from "../../components/landing/LandingHeader.vue";
  import LandingFooter from "../../components/landing/LandingFooter.vue";
  import {initLandingPlugins} from "../../helpers/landing";

  export default {
    name: 'PublicLayout',
    components: { LandingHeader, LandingFooter },
    async mounted() {
      // Initialise les plugins Sash UNE SEULE FOIS
      await this.$nextTick();
      initLandingPlugins();
    },
  }
</script>
